// on choose campaign page load.
export const tagOnCampaignPageLoad = () => {
  window.MyTIQ &&
    window.MyTIQ.view({
      service_application_event: 'start',
      page_event: 'view',
      service_application_step:'myvodacom: my fibre: deals: special leads form',
      service_application_name: 'myvodacom: my fibre: deals form (transaction)',
      service_application_type: 'transaction',
      page_name: 'myvodacom: my fibre: deals: special leads form',
    });
};

// when user start filling the form
export const tagOnCampaignFormStarted = () => {
  window.MyTIQ &&
    window.MyTIQ.link({
      page_form_name: 'myvodacom: my fibre: deals: special leads form',
      page_form_event: 'started',
    });
};

// when user start searching for coverage
export const tagOnCampaignCoverageSearch = () => {
  window.MyTIQ &&
    window.MyTIQ.link({
      service_application_step: 'myvodacom: my fibre: deals: special leads form: check coverage',
      service_application_name: 'myvodacom: my fibre: deals form (transaction)',
      service_application_type: 'transaction',
    });
};

// when fibre is available, we
export const tagOnFibreIsAvailablePageLoad = () => {
  window.MyTIQ &&
    window.MyTIQ.view({
      page_event: 'view',
      service_application_step:
        'myvodacom: my fibre: deals: special leads form: fibre is available',
      service_application_name: 'myvodacom: my fibre: deals form (transaction)',
      service_application_type: 'transaction',
      fibre_coverage_status: 'Available',
      page_name: 'myvodacom: my fibre: deals: special leads form: fibre outcome',
    });
};

// when fibre is not available, we
export const tagOnFibreIsNotAvailablePageLoad = () => {
  window.MyTIQ &&
    window.MyTIQ.view({
      page_event: 'view',
      service_application_step: 'myvodacom: my fibre: deals: special leads form: fibre is not available',
      service_application_name: 'myvodacom: my fibre: deals form (transaction)',
      service_application_type: 'transaction',
      fibre_coverage_status: 'Not Available',
      page_name: 'myvodacom: my fibre: deals: special leads form: fibre outcome',
    });
};

// on successful submit of form
export const tagOnCampaignSubmitSuccess = (hashedId, referenceNo) => {
  window.MyTIQ &&
    window.MyTIQ.view({
      service_application_event: 'finish',
      page_event: 'view',
      service_application_step: 'myvodacom: my fibre: deals: special leads form: success',
      service_application_name: 'myvodacom: my fibre: deals form (transaction)',
      service_application_type: 'transaction',
      page_name: 'myvodacom: my fibre: deals: special leads form: success',
      visitor_customer_id: [hashedId],
      page_form_name: 'myvodacom: fibre: home: support: campaign lead: success',
      page_form_event: 'success',
      sales_event: 'fibre_special_lead',
      sales_order_id: [referenceNo],
    });
};

// on successful submit of form
export const tagOnCampaignSubmitError = (error) => {
  window.MyTIQ &&
    window.MyTIQ.view({
      page_form_event: 'error',
      page_errors: [error],
      page_name: 'myvodacom: my fibre: deals: special leads: journey',
    });
};
